/**
 * Root reducer.
 * @module reducers/root
 */


/**
 * Root reducer.
 * @function
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */

import { loginJwtReducer } from "./loginJwtReducer";
import { loginTokenReducer } from "./loginTokenReducer";

const reducers = {
    loginJwt: loginJwtReducer,
    userSession: loginTokenReducer,
};

export default reducers;
